import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useConfig } from "../../utensils/ConfigContext";
import "./SnackNewClass.css";
import SnackTimeTable from "./timetable/SnackTimeTable";

const SnackNewTemplate = ({ show, onHide, classId = null, onSave }) => {
  const { apiToken } = useConfig();

  const [formData, setFormData] = useState({
    Nombre: "",
    Detalle: "",
    Instructor: "",
    Programacion: "",
    Estado: true,
    Cupo: "",
    Zona: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!classId) {
      setFormData({
        Nombre: "",
        Detalle: "",
        Instructor: "",
        Programacion: "",
        Estado: true,
        Cupo: "",
        Zona: "",
      });
      return;
    }

    const fetchClass = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `https://api.baserow.io/api/database/rows/table/574697/${classId}/?user_field_names=true`,
          { headers: { Authorization: `Token ${apiToken}` } }
        );
        const data = await res.json();
        setFormData({
          Nombre: data.Nombre || "",
          Detalle: data.Detalle || "",
          Instructor: data.Instructor || "",
          Programacion:
            typeof data.Programacion === "string"
              ? data.Programacion
              : JSON.stringify(data.Programacion || ""),
          Estado: data.Estado ?? true,
          Cupo: data.Cupo || "",
          Zona: data.Zona || "",
        });
      } catch (err) {
        console.error("Error al cargar plantilla:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClass();
  }, [classId, apiToken]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.Nombre.trim() ||
      !formData.Detalle.trim() ||
      !formData.Instructor.trim() ||
      !formData.Programacion.trim() ||
      !formData.Cupo ||
      !formData.Zona
    ) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    setLoading(true);

    const url = classId
      ? `https://api.baserow.io/api/database/rows/table/574697/${classId}/?user_field_names=true`
      : "https://api.baserow.io/api/database/rows/table/574697/?user_field_names=true";

    const method = classId ? "PATCH" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${apiToken}`,
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Error al guardar la plantilla");

      const data = await res.json();
      onSave && onSave(data);
      onHide();
    } catch (err) {
      console.error(err);
      alert("Ocurrió un error al guardar la plantilla.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {classId ? "Editar plantilla" : "Nueva plantilla"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <Form onSubmit={handleSubmit} className="snack-template-form">
            <Form.Group controlId="Nombre">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                name="Nombre"
                value={formData.Nombre}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="Instructor">
              <Form.Label>Instructor</Form.Label>
              <Form.Control
                type="text"
                name="Instructor"
                value={formData.Instructor}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="Cupo">
              <Form.Label>Cupo máximo</Form.Label>
              <Form.Control
                type="number"
                name="Cupo"
                value={formData.Cupo}
                onChange={handleChange}
                min={1}
                required
              />
            </Form.Group>

            <Form.Group controlId="Detalle">
              <Form.Label>Detalle</Form.Label>
              <Form.Control
                as="textarea"
                name="Detalle"
                value={formData.Detalle}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="Zona">
              <Form.Label>Zona</Form.Label>
              <Form.Control
                as="select"
                name="Zona"
                value={formData.Zona}
                onChange={handleChange}
                required
              >
                <option value="">Selecciona una zona</option>
                <option value="ZONA VIP METAGYM">ZONA VIP METAGYM</option>
                <option value="ZONA VIP FITNESS FOR LIFE">
                  ZONA VIP FITNESS FOR LIFE
                </option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="Programacion">
              <Form.Label>Horario</Form.Label>
              <SnackTimeTable
                value={formData.Programacion}
                onChange={(jsonString) =>
                  setFormData((prev) => ({
                    ...prev,
                    Programacion: jsonString,
                  }))
                }
              />
            </Form.Group>

            <Form.Check
              type="checkbox"
              label="Plantilla activa"
              name="Estado"
              checked={formData.Estado}
              onChange={handleChange}
            />

            <div className="mt-2">
              <span
                className={`badge ${
                  formData.Estado ? "bg-success" : "bg-secondary"
                }`}
              >
                {formData.Estado ? "Plantilla activa" : "Plantilla inactiva"}
              </span>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="secondary" onClick={onHide} className="me-2">
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {classId ? "Guardar cambios" : "Crear plantilla"}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SnackNewTemplate;
